import { defineComponent as _defineComponent } from 'vue';
import { faArrowLeft, faArrowRight, faUnlink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { ref, watch } from "vue";
import localize from "@/utils/localization";
import ClickToEdit from "@/components/Collections/common/ClickToEdit.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PairedElementView',
    props: {
        pair: null
    },
    emits: ["onPairRename", "onUnpair"],
    setup(__props, { emit }) {
        const props = __props;
        const elementName = ref(props.pair.name);
        watch(elementName, () => {
            emit("onPairRename", elementName.value);
        });
        return { __sfc: true, props, emit, elementName, faArrowLeft, faArrowRight, faUnlink, FontAwesomeIcon, BButton, localize, ClickToEdit };
    }
});
